'use client';

import React from 'react';
import ModalComponent from 'components/common/ModalComponent';
import { showAlert } from 'services/alerts.service';
import PropTypes from 'prop-types';

const GroupOptionsModal = ({ isOpen, handleClose, selectedGroup, handleSave }) => {
  const handleGroupSave = formData => {
    if (!formData.groupName || formData.groupName.trim() === '') {
      showAlert({
        text: 'Group Name is required',
        icon: 'warning'
      });
      return;
    }

    const dataToSave = selectedGroup?.groupId
      ? { ...formData, groupId: selectedGroup.groupId }
      : { ...formData, groupId: undefined };

    handleSave(dataToSave);
    handleClose();
  };

  return (
    <ModalComponent
      title={selectedGroup?.groupId ? 'Update Group' : 'Create Group'}
      isOpen={isOpen}
      onClose={handleClose}
      initialData={{
        groupId: selectedGroup?.groupId || '',
        groupName: selectedGroup?.groupName || ''
      }}
      onSave={handleGroupSave}
    >
      {({ formData, handleChange }) => (
        <div className="space-y-4 w-96">
          <label className="block text-sm font-medium">
            Group Name *
            <input
              type="text"
              name="groupName"
              value={formData.groupName}
              onChange={handleChange}
              className="w-full mt-1 p-2 border rounded"
            />
          </label>
        </div>
      )}
    </ModalComponent>
  );
};

GroupOptionsModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedGroup: PropTypes.object,
  handleSave: PropTypes.func
};

export default GroupOptionsModal;
